import React from 'react'
import { cardLayout } from '../../assets/images/focusCard'
import './style.css';
export default function FocusCard({title,content,icon,id,top,marginLeft,fix,bg}) {
    

    return (
        <div style={{
            top:top,
            marginLeft:marginLeft,
            // position:fix?"fixed":"absolute"
            position:fix?"fixed": "sticky"
        }} className='fcard-main'>
            <img src={`data:image/svg+xml;utf8,${encodeURIComponent(cardLayout(bg))}`} className='focus-img-focusCard' />
            <div className='fcard-content-main'>
                <div style={{display:"flex",justifyContent:"space-between",marginTop:45}}>
                <p className='fcard-title-text'>{title}</p>
                <p className='fcard-id-text'>{id}</p>
                </div>
                <p className='fcard-content-text'>{content}</p>
                <div style={{flex:1}} />
                <div className='fcard-icon-container'>
                    <p className='fcard-icon-text'>{icon}</p>
                </div>
            </div>
        </div>
    )
}
